var map = {
	"./avatar1.png": "OTUQ",
	"./avatar2.png": "nxhq",
	"./avatar3.png": "g+1R",
	"./avatar4.png": "ZS9R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PVby";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/avatar.*\.png$
// module id = PVby
// module chunks = 0